import { device } from 'components/styles/MediaQuery';
import styled, { css } from 'styled-components';
import { ScSelectMainProps } from '../../types';

interface ScSelectBlockProps extends ScSelectMainProps {
  active?: boolean;
  error: boolean;
  disabled?: boolean;
  selected?: boolean;
  canReset?: boolean;
  lightColoredDropMode?: boolean;
  lightBg?: boolean;
}

export const ScSelectButton = styled.div<ScSelectBlockProps>`
  z-index: 1;
  position: relative;
  cursor: ${({ disabled }) => (!!disabled ? 'default' : 'pointer')};
  padding: 10px 16px;
  padding-left: 0;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 0;
  flex-wrap: nowrap;
  width: 100%;
  font-weight: 400;
  color: transparent;
  border: none;
  background-color: ${({ theme, lightBg, selected }) =>
    selected
      ? theme.whiteColor
      : lightBg
      ? theme.grayColor5
      : theme.grayColor4};

  border-radius: 12px;

  ${({ small }) => {
    switch (false) {
      case small != null:
        return css`
          font-size: 14px;
        `;
      default:
        return css`
          font-size: 16px;
          line-height: 28px;
        `;
    }
  }}

  ${({ lightColoredDropMode }) =>
    lightColoredDropMode &&
    css`
      background: ${({ theme }) => theme.grayColor3};
      color: transparent;
      border: none;
      height: 48px;
    `}

  & > .border {
    position: absolute;
    z-index: 1;
    inset: 0;
    border-radius: 12px;
    padding: 2px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: ${({ theme, active, error }) =>
        active
          ? theme.greenMarineGradient
          : error
          ? theme.pinkRougeGradient
          : 'transparent'};
    }
  }

  & > .content {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    column-gap: 12px;
    z-index: 2;
    position: relative;
    overflow: hidden;

    & > .value {
      width: calc(100% - 36px);
      white-space: nowrap;
      color: ${({ theme, active, selected }) =>
        selected
          ? theme.blackColor
          : active
          ? theme.whiteColor
          : theme.secondaryColor};

      & > .name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        transition: color 0.3s ease;
        padding-left: 16px;
        font-size: 16px;
      }

      &.filled {
        padding-top: 16px;
      }

      &.with-icon {
        display: flex;
        gap: 8px;
        padding-left: 16px;

        & > .name {
          padding-left: 0;
        }

        img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          object-fit: contain;
        }
      }
    }
  }

  & svg path {
    transition: fill-opacity 0.2s;
  }

  @media (hover: hover) {
    &:hover svg path {
      fill-opacity: 1;
    }

    &:hover {
      ${({ selected, theme, active, error }) =>
        selected &&
        css`
        & > .border {

          &::before {
            background: ${theme.greenMarineGradient};
        }
      `}
    }
  }

  .select-btn-action {
    position: relative;

    ${({ active, up }) => css`
      background: transparent;
      height: 100%;
      display: flex;
      align-items: center;

      & > svg {
        transform: ${active
          ? `rotate(${up ? `-90deg` : `-270deg`})`
          : `rotate(${up ? `-270deg` : `-90deg`})`};
      }
    `}

    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;

    & > button svg {
      object-fit: contain;
    }

    & > svg {
      transition: transform 0.3s;
    }
  }

  .placeholder {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-left: 16px;
  }

  @media (hover: hover) {
    &:hover {
      .content {
        .value {
          color: ${({ theme, disabled, selected }) =>
            selected
              ? theme.blackColor
              : !!disabled
              ? theme.grayColor6
              : theme.whiteColor};
        }
      }
      .select-btn-action {
        svg {
          path {
            fill: ${({ theme, selected }) =>
              selected ? theme.secondaryColor : theme.whiteColor};
            fill-opacity: 1;
            will-change: fill, fill-opacity;
          }

          @media (${device.mobile}) {
            path {
              fill: ${({ theme }) => theme.secondaryColor};
            }
          }
        }
      }
    }
  }
`;
